import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faFilter,
  faLayerGroup,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import Swal from "sweetalert2";

import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";

import "bulma/css/bulma.css";
import "../../../../../../../index.css";

const getAdminId = () => {
  const storedId = localStorage.getItem("id_admin");
  if (!storedId) return null;

  try {
    return JSON.parse(storedId);
  } catch {
    return storedId;
  }
};

const pageStyles = `
  @keyframes predikatShimmer {
    0% { background-position: -700px 0; }
    100% { background-position: 700px 0; }
  }

  .predikat-filter-card {
    width: 100%;
    margin-bottom: 18px;
    padding: 18px;
    border: 1px solid #e6ebf4;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 4px 18px rgba(39, 71, 140, 0.06);
  }

  .predikat-filter-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }

  .predikat-filter-icon {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #edf4ff;
    color: #315fba;
  }

  .predikat-filter-title {
    margin: 0;
    color: #1f2a44;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
  }

  .predikat-filter-subtitle {
    margin: 2px 0 0;
    color: #8a96aa;
    font-size: 12px;
    line-height: 1.35;
  }

  .predikat-filter-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px 12px;
    align-items: end;
  }

  .predikat-filter-field {
    min-width: 0;
  }

  .predikat-filter-label {
    display: block;
    margin-bottom: 7px;
    color: #4c5870;
    font-size: 12px;
    font-weight: 700;
  }

  .predikat-select-wrap {
    position: relative;
  }

  .predikat-select-wrap::after {
    content: "";
    position: absolute;
    right: 13px;
    top: 50%;
    width: 7px;
    height: 7px;
    border-right: 1.7px solid #72809a;
    border-bottom: 1.7px solid #72809a;
    transform: translateY(-68%) rotate(45deg);
    pointer-events: none;
  }

  .predikat-filter-select {
    width: 100%;
    height: 42px;
    padding: 0 36px 0 12px;
    border: 1px solid #dce3ef;
    border-radius: 9px;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    background: #ffffff;
    color: #2f3a50;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .predikat-filter-select:hover:not(:disabled) {
    border-color: #b9c9e7;
  }

  .predikat-filter-select:focus {
    border-color: #4c78d3;
    box-shadow: 0 0 0 3px rgba(76, 120, 211, 0.12);
  }

  .predikat-filter-select:disabled {
    background: #f6f8fb;
    color: #9aa5b6;
    cursor: not-allowed;
  }

  .predikat-filter-button-field {
    display: flex;
    align-items: flex-end;
  }

  .predikat-filter-actions {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    width: 100%;
  }

  .predikat-filter-button {
    width: 100%;
    min-height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 16px;
    border: 1px solid #e9a51a;
    border-radius: 9px;
    background: #e9a51a;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(233, 165, 26, 0.2);
    transition: transform 0.15s ease, background 0.2s ease;
  }

  .predikat-filter-button:hover:not(:disabled) {
    transform: translateY(-1px);
    background: #d89512;
  }

  .predikat-filter-button:disabled {
    opacity: 0.58;
    cursor: not-allowed;
  }

  .predikat-shimmer {
    position: relative;
    overflow: hidden;
    background: linear-gradient(90deg, #e9eff8 8%, #f7f9fd 18%, #e9eff8 33%);
    background-size: 1100px 100%;
    animation: predikatShimmer 1.25s linear infinite;
  }

  .predikat-shimmer-label {
    width: 74px;
    height: 10px;
    margin-bottom: 8px;
    border-radius: 5px;
  }

  .predikat-shimmer-control,
  .predikat-shimmer-button {
    width: 100%;
    height: 42px;
    border-radius: 9px;
  }

  .predikat-search-section {
    margin-bottom: 14px;
  }

  .predikat-table-header {
    min-height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 18px;
    border-bottom: 1px solid #e6ebf4;
  }

  .predikat-table-title {
    margin: 0;
    color: #17233d;
    font-size: 16px;
    font-weight: 800;
  }

  .predikat-table-header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

  .predikat-header-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .predikat-header-button {
    min-width: 98px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 0 14px;
    border-radius: 9px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }

  .predikat-header-edit {
    border: 1px solid #f3b33d;
    background: #fffaf0;
    color: #e79a00;
  }

  .predikat-header-delete {
    border: 1px solid #ff9bad;
    background: #fff7f8;
    color: #f04461;
  }

  .bobot-semester-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .bobot-fields-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 14px;
  }

  .bobot-filter-info {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 22px;
    margin-bottom: 18px;
    padding: 15px;
    border: 1px solid #d5e2ff;
    border-radius: 10px;
    background: #f5f8ff;
  }

  .bobot-filter-info-item {
    min-width: 0;
  }

  .bobot-filter-info-label {
    display: block;
    margin-bottom: 4px;
    color: #8a97ad;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.35px;
    text-transform: uppercase;
  }

  .bobot-filter-info-value {
    display: block;
    color: #394760;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .bobot-semester-option {
    min-height: 46px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 13px;
    border: 1px solid #dce3ef;
    border-radius: 9px;
    color: #35425a;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
  }

  .bobot-semester-option input {
    width: 17px;
    height: 17px;
    accent-color: #3f5bea;
  }

  .predikat-semester-tabs {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px;
    border: 1px solid #dce3ef;
    border-radius: 12px;
    background: #f7f9fc;
  }

  .predikat-semester-tab {
    min-width: 104px;
    height: 38px;
    padding: 0 16px;
    border: 0;
    border-radius: 9px;
    background: transparent;
    color: #58657a;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
  }

  .predikat-semester-tab.active {
    background: #ffffff;
    color: #3f5bea;
    box-shadow: 0 2px 7px rgba(45, 66, 128, 0.12);
  }

  .predikat-semester-tab:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .predikat-table {
    min-width: 680px;
  }

  .predikat-table .predikat-col-number {
    width: 78px;
  }

  .predikat-table .predikat-col-value {
    width: 180px;
  }

  .predikat-table .predikat-col-description {
    width: auto;
  }

  .predikat-table .predikat-col-action {
    width: 130px;
    text-align: center !important;
  }

  .predikat-value-badge {
    min-width: 58px;
    height: 31px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    border: 1px solid #d7e4fb;
    border-radius: 9px;
    background: #edf4ff;
    color: #315fba;
    font-size: 13px;
    font-weight: 800;
  }

  .predikat-description-text {
    display: block;
    width: 100%;
    color: #59667d;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
    white-space: normal;
    overflow-wrap: break-word;
  }

  @media (max-width: 900px) and (min-width: 781px) {
    .predikat-filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 780px) {
    .predikat-filter-card {
      padding: 15px;
      border-radius: 12px;
    }

    .predikat-filter-grid {
      grid-template-columns: 1fr;
      gap: 11px;
    }

    .predikat-filter-actions {
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .predikat-table {
      min-width: 640px;
    }

    .predikat-table-header {
      align-items: stretch;
      flex-direction: column;
    }

    .predikat-table-header-right {
      width: 100%;
      align-items: stretch;
      flex-direction: column;
    }

    .predikat-header-actions {
      width: 100%;
    }

    .predikat-header-button {
      flex: 1;
    }

    .bobot-filter-info,
    .bobot-semester-options,
    .bobot-fields-grid {
      grid-template-columns: 1fr;
    }

    .predikat-semester-tabs {
      width: 100%;
    }

    .predikat-semester-tab {
      min-width: 0;
      flex: 1;
    }

    .predikat-page .page-header-top {
      align-items: flex-start !important;
      flex-direction: column;
      gap: 14px;
    }

    .predikat-page .page-header-top .ml-auto {
      width: 100%;
      margin-left: 0 !important;
    }

    .predikat-page .module-header-button {
      width: 100%;
      justify-content: center;
    }
  }
`;

const getRows = (responseData) => {
  if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
  if (Array.isArray(responseData?.data)) return responseData.data;
  if (Array.isArray(responseData?.result)) return responseData.result;
  if (Array.isArray(responseData)) return responseData;
  return [];
};

const getBranchId = (item) =>
  item?.branch_code || item?.id || item?.ysb_branch_id || "";

const getSchoolId = (item) =>
  item?.school_code || item?.id || item?.ysb_school_id || "";

const getRecordFilterValue = (record, key) => {
  const aliases = {
    ysb_academic_year_id: ["ysb_academic_year_id", "academic_year_id"],
    ysb_semester_id: ["ysb_semester_id", "semester_id"],
    ysb_branch_id: ["ysb_branch_id", "branch_id", "branch_code"],
    ysb_school_id: ["ysb_school_id", "school_id", "school_code"],
  };

  const keys = aliases[key] || [key];
  const source = record?.data && !Array.isArray(record.data)
    ? { ...record, ...record.data }
    : record;

  for (const alias of keys) {
    const value = source?.[alias];
    if (value !== undefined && value !== null && value !== "") return value;
  }

  return "";
};

const recordMatchesFilters = (record, activeFilters) =>
  [
    "ysb_academic_year_id",
    "ysb_semester_id",
    "ysb_branch_id",
    "ysb_school_id",
  ].every((key) => {
    const recordValue = getRecordFilterValue(record, key);
    return (
      recordValue !== "" &&
      String(recordValue) === String(activeFilters[key])
    );
  });

const isActive = (item) =>
  Number(item?.status) === 1 ||
  item?.is_active === true ||
  Number(item?.is_active) === 1;

const BOBOT_FIELDS = [
  { key: "bobot_asts", keterangan: "ASTS" },
  { key: "bobot_asas", keterangan: "ASAS" },
  { key: "bobot_sumatif_harian", keterangan: "Sumatif Harian" },
  { key: "bobot_sumatif_akhir", keterangan: "Sumatif Akhir" },
];

const mapBobotRecordToRows = (record) => {
  if (!record?.id) return [];
  return BOBOT_FIELDS.map((field) => ({
    id: `${record.id}-${field.key}`,
    record_id: record.id,
    key: field.key,
    keterangan: field.keterangan,
    bobot: record[field.key],
  }));
};

export default function Predikat() {
  document.title = "Atur Bobot Nilai Leger";

  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level") || "developer";

  const [semesterOptions, setSemesterOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);

  const [loadingMaster, setLoadingMaster] = useState(true);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const [filters, setFilters] = useState({
    ysb_academic_year_id: "",
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  const [getData, setGetData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);
  const [hasLoadedData, setHasLoadedData] = useState(false);
  const hasAutoLoadedInitialData = useRef(false);
  const pendingSemesterLoad = useRef(false);
  const latestRequestId = useRef(0);

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [id, setId] = useState("");
  const [dataUpdate, setDataUpdate] = useState(null);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const filterComplete = useMemo(
    () =>
      Boolean(
        filters.ysb_academic_year_id &&
          filters.ysb_semester_id &&
          filters.ysb_branch_id &&
          filters.ysb_school_id
      ),
    [filters]
  );

  const selectedSemester = useMemo(
    () =>
      semesterOptions.find(
        (item) => String(item?.id) === String(filters.ysb_semester_id)
      ) || null,
    [filters.ysb_semester_id, semesterOptions]
  );

  const academicYearOptions = useMemo(() => {
    const years = new Map();

    semesterOptions.forEach((item) => {
      const yearId = item?.ysb_academic_year_id;
      if (!yearId || years.has(String(yearId))) return;

      years.set(String(yearId), {
        id: yearId,
        name: item?.name_year || item?.academic_year || "Tahun Ajaran",
      });
    });

    return Array.from(years.values());
  }, [semesterOptions]);

  const semestersForSelectedYear = useMemo(
    () =>
      semesterOptions.filter(
        (item) =>
          String(item?.ysb_academic_year_id) ===
          String(filters.ysb_academic_year_id)
      ),
    [filters.ysb_academic_year_id, semesterOptions]
  );

  const selectedBranch = useMemo(
    () =>
      branchOptions.find(
        (item) => String(getBranchId(item)) === String(filters.ysb_branch_id)
      ) || null,
    [branchOptions, filters.ysb_branch_id]
  );

  const selectedSchool = useMemo(
    () =>
      schoolOptions.find(
        (item) => String(getSchoolId(item)) === String(filters.ysb_school_id)
      ) || null,
    [filters.ysb_school_id, schoolOptions]
  );

  const filterLabels = useMemo(
    () => ({
      academicYear: selectedSemester
        ? selectedSemester?.name_year || selectedSemester?.academic_year || "-"
        : "-",
      branch:
        selectedBranch?.branch_name || selectedBranch?.name_branch || "-",
      school:
        selectedSchool?.school_name || selectedSchool?.name_school || "-",
    }),
    [selectedBranch, selectedSchool, selectedSemester]
  );

  const clearTable = useCallback(() => {
    latestRequestId.current += 1;
    setGetData([]);
    setHasLoadedData(false);
    setSearchKeyword("");
    setTablePage(1);
  }, []);

  const fetchInitialMaster = useCallback(async () => {
    setLoadingMaster(true);

    try {
      const [semesterResponse, branchResponse] = await Promise.all([
        APIMS.get("/api/access/semesters", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 1000,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
        }),
        APIMS.get("/api/access/branches", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 1000,
            ascending: 1,
            search: "",
            level: storageLevel,
          },
        }),
      ]);

      const semesters = getRows(semesterResponse?.data).sort((first, second) => {
        const yearComparison = String(second?.name_year || "").localeCompare(
          String(first?.name_year || ""),
          "id",
          { numeric: true, sensitivity: "base" }
        );

        if (yearComparison !== 0) return yearComparison;
        return Number(first?.semester || 0) - Number(second?.semester || 0);
      });

      const branches = getRows(branchResponse?.data).sort((first, second) =>
        String(first?.branch_name || "").localeCompare(
          String(second?.branch_name || ""),
          "id",
          { numeric: true, sensitivity: "base" }
        )
      );

      setSemesterOptions(semesters);
      setBranchOptions(branches);

      const activeSemester = semesters.find(isActive) || semesters[0];
      const firstBranch = branches[0];

      setFilters((previous) => ({
        ...previous,
        ysb_academic_year_id:
          activeSemester?.ysb_academic_year_id || "",
        ysb_semester_id: activeSemester?.id || "",
        ysb_branch_id: getBranchId(firstBranch),
      }));
    } catch (error) {
      setSemesterOptions([]);
      setBranchOptions([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data filter bobot",
      });
    } finally {
      setLoadingMaster(false);
    }
  }, [fetchParams, storageLevel]);

  useEffect(() => {
    fetchInitialMaster();
  }, [fetchInitialMaster]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      if (!branchId) {
        setSchoolOptions([]);
        return;
      }

      setLoadingSchool(true);
      setSchoolOptions([]);

      try {
        const response = await APIMS.get("/api/access/schools", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 1000,
            ascending: 1,
            search: "",
            branch: branchId,
            level: storageLevel,
          },
        });

        let schools = getRows(response?.data);

        schools = schools.filter((item) => {
          const itemBranchId = item?.ysb_branch_id || item?.branch_code;
          return !itemBranchId || String(itemBranchId) === String(branchId);
        });

        if (String(branchId) === "BKS") {
          schools = schools.filter(
            (item) => String(getSchoolId(item)) !== "BASEMENT_BEKASI"
          );
        }

        const schoolOrder = ["SD", "SMP", "SMA"];
        schools = [...schools].sort((first, second) => {
          const firstName = String(first?.school_name || "").toUpperCase();
          const secondName = String(second?.school_name || "").toUpperCase();
          const firstOrder = schoolOrder.findIndex((level) =>
            firstName.includes(level)
          );
          const secondOrder = schoolOrder.findIndex((level) =>
            secondName.includes(level)
          );

          const safeFirstOrder = firstOrder === -1 ? 99 : firstOrder;
          const safeSecondOrder = secondOrder === -1 ? 99 : secondOrder;

          if (safeFirstOrder !== safeSecondOrder) {
            return safeFirstOrder - safeSecondOrder;
          }

          return firstName.localeCompare(secondName, "id", {
            numeric: true,
            sensitivity: "base",
          });
        });

        setSchoolOptions(schools);
        setFilters((previous) => ({
          ...previous,
          ysb_school_id: getSchoolId(schools[0]),
        }));
      } catch (error) {
        setSchoolOptions([]);
        setFilters((previous) => ({
          ...previous,
          ysb_school_id: "",
        }));

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message || "Gagal memuat data sekolah",
        });
      } finally {
        setLoadingSchool(false);
      }
    },
    [fetchParams, storageLevel]
  );

  useEffect(() => {
    clearTable();
    setFilters((previous) => ({
      ...previous,
      ysb_school_id: "",
    }));
    fetchSchoolsByBranch(filters.ysb_branch_id);
  }, [clearTable, fetchSchoolsByBranch, filters.ysb_branch_id]);

  const GetResponseData = useCallback(async () => {
    if (!filterComplete) {
      ToastError.fire({
        icon: "error",
        title: "Lengkapi tahun ajaran, cabang, dan sekolah",
      });
      return;
    }

    const requestId = latestRequestId.current + 1;
    latestRequestId.current = requestId;
    const activeFilters = { ...filters };
    setIsFetching(true);

    try {
      const filterPayload = {
        ysb_academic_year_id: activeFilters.ysb_academic_year_id,
        ysb_semester_id: activeFilters.ysb_semester_id,
        ysb_branch_id: activeFilters.ysb_branch_id,
        ysb_school_id: activeFilters.ysb_school_id,
      };
      const response = await APISD.get("/api/standar-calculation", {
        ...fetchParams,
        // Dikirim melalui query dan body agar tetap kompatibel dengan API lama.
        params: filterPayload,
        data: filterPayload,
      });

      if (requestId !== latestRequestId.current) return;

      const records = getRows(response?.data);
      const record = records.find((item) =>
        recordMatchesFilters(item, activeFilters)
      ) || null;
      setGetData(mapBobotRecordToRows(record));
      setHasLoadedData(true);
      setTablePage(1);
    } catch (error) {
      if (requestId !== latestRequestId.current) return;
      setGetData([]);
      setHasLoadedData(true);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message || "Gagal memuat data bobot",
      });
    } finally {
      if (requestId === latestRequestId.current) setIsFetching(false);
    }
  }, [fetchParams, filterComplete, filters]);

  useEffect(() => {
    if (
      hasAutoLoadedInitialData.current ||
      loadingMaster ||
      loadingSchool ||
      !filterComplete
    ) {
      return;
    }

    hasAutoLoadedInitialData.current = true;
    GetResponseData();
  }, [
    GetResponseData,
    filterComplete,
    loadingMaster,
    loadingSchool,
  ]);

  useEffect(() => {
    if (!pendingSemesterLoad.current || !filterComplete) return;

    pendingSemesterLoad.current = false;
    GetResponseData();
  }, [GetResponseData, filterComplete, filters.ysb_semester_id]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    clearTable();

    if (name === "ysb_academic_year_id") {
      const semestersInYear = semesterOptions.filter(
        (item) => String(item?.ysb_academic_year_id) === String(value)
      );
      const defaultSemester =
        semestersInYear.find(isActive) ||
        semestersInYear.find((item) => Number(item?.semester) === 1) ||
        semestersInYear[0];

      setFilters((previous) => ({
        ...previous,
        ysb_academic_year_id: value,
        ysb_semester_id: defaultSemester?.id || "",
      }));
      return;
    }

    setFilters((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSemesterChange = (semester) => {
    if (!semester?.id || String(semester.id) === String(filters.ysb_semester_id)) {
      return;
    }

    clearTable();
    pendingSemesterLoad.current = true;
    setFilters((previous) => ({
      ...previous,
      ysb_semester_id: semester.id,
    }));
  };

  const deleteById = () => {
    Swal.fire({
      title: "Apakah kamu yakin?",
      text: "Seluruh data bobot pada filter ini akan dihapus.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const recordId = getData[0]?.record_id;
      if (!recordId) return;
      try {
        await APISD.delete(`/api/standar-calculation/destroy/${recordId}`, {
          ...fetchParams,
          data: { update_by: getAdminId() },
        });
        setGetData([]);
        ToastSuccess.fire({ icon: "success", title: "Seluruh data bobot berhasil dihapus" });
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error?.response?.data?.message || "Gagal menghapus data bobot",
        });
      }
    });
  };

  const filteredData = useMemo(() => {
    const keyword = searchKeyword.trim().toLowerCase();
    const source = Array.isArray(getData) ? getData : [];

    const rows = !keyword
      ? source
      : source.filter((item) => {
          const score = String(item?.bobot ?? "").toLowerCase();
          const description = String(item?.keterangan || "").toLowerCase();
          return score.includes(keyword) || description.includes(keyword);
        });

    return rows;
  }, [getData, searchKeyword]);

  const totalRows = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / Math.max(1, rowsPerPage)));

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword]);

  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
    if (tablePage < 1) setTablePage(1);
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const start = (tablePage - 1) * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, rowsPerPage, tablePage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let page = 1; page <= totalPages; page += 1) pages.push(page);
      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);
    if (left > 2) pages.push("...");

    for (let page = left; page <= right; page += 1) {
      if (page !== 1 && page !== totalPages) pages.push(page);
    }

    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages.filter(
      (value, index, array) => array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    setTablePage(
      Math.min(Math.max(1, Number(nextPage) || 1), totalPages)
    );
  };

  const handleOpenAdd = () => {
    if (!filterComplete) {
      ToastError.fire({
        icon: "error",
        title: "Lengkapi filter sebelum menambah bobot",
      });
      return;
    }

    setModalAdd(true);
  };

  const hasDataForAllSemesters = getData.length > 0;

  const viewModalUpdate = (bobotId, bobot) => {
    setId(bobotId);
    setDataUpdate(bobot);
    setModalUpdate(true);
  };

  const startRow =
    totalRows === 0
      ? 0
      : Math.min((tablePage - 1) * rowsPerPage + 1, totalRows);
  const endRow = Math.min(tablePage * rowsPerPage, totalRows);

  return (
    <div className="body module-page predikat-page">
      <style>{pageStyles}</style>

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          semesterOptions={semestersForSelectedYear}
          filterData={filters}
          filterLabels={filterLabels}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          currentData={getData}
          filterData={filters}
          filterLabels={filterLabels}
          show={modalUpdate}
          onHide={() => {
            setModalUpdate(false);
            setId("");
            setDataUpdate(null);
          }}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faLayerGroup} />
            </span>
            <h4 className="page-title-text">Atur Bobot</h4>
          </div>
        </div>

        <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
          <ol className="custom-breadcrumb">
            <li className="custom-breadcrumb-item">
              <Link to="/leger-siakad">Leger</Link>
            </li>
            <li className="custom-breadcrumb-separator">/</li>
            <li className="custom-breadcrumb-item active" aria-current="page">
              Atur Bobot
            </li>
          </ol>
        </nav>
      </div>

      <div className="body-content module-content">
        <section className="predikat-filter-card">
          
          {loadingMaster ? (
            <div className="predikat-filter-grid">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  className="predikat-filter-field"
                  key={`predikat-filter-shimmer-${index}`}
                >
                  {/* <div className="predikat-shimmer predikat-shimmer-label" /> */}
                  <div className="predikat-shimmer predikat-shimmer-control" />
                </div>
              ))}
            </div>
          ) : (
            <div className="predikat-filter-grid">
              <div className="predikat-filter-field">
                <label className="predikat-filter-label" htmlFor="predikat-year">
                  Tahun Ajaran
                </label>
                <div className="predikat-select-wrap">
                  <select
                    id="predikat-year"
                    name="ysb_academic_year_id"
                    className="predikat-filter-select"
                    value={filters.ysb_academic_year_id}
                    onChange={handleFilterChange}
                  >
                    <option value="">Pilih Tahun Ajaran</option>
                    {academicYearOptions.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="predikat-filter-field">
                <label className="predikat-filter-label" htmlFor="predikat-branch">
                  Cabang
                </label>
                <div className="predikat-select-wrap">
                  <select
                    id="predikat-branch"
                    name="ysb_branch_id"
                    className="predikat-filter-select"
                    value={filters.ysb_branch_id}
                    onChange={handleFilterChange}
                  >
                    <option value="">Pilih Cabang</option>
                    {branchOptions.map((item) => (
                      <option key={getBranchId(item)} value={getBranchId(item)}>
                        {item?.branch_name || item?.name_branch || "Cabang"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="predikat-filter-field">
                <label className="predikat-filter-label" htmlFor="predikat-school">
                  Sekolah
                </label>
                <div className="predikat-select-wrap">
                  <select
                    id="predikat-school"
                    name="ysb_school_id"
                    className="predikat-filter-select"
                    value={filters.ysb_school_id}
                    onChange={handleFilterChange}
                    disabled={loadingSchool || !filters.ysb_branch_id}
                  >
                    <option value="">
                      {loadingSchool ? "Memuat sekolah..." : "Pilih Sekolah"}
                    </option>
                    {schoolOptions.map((item) => (
                      <option key={getSchoolId(item)} value={getSchoolId(item)}>
                        {item?.school_name || item?.name_school || "Sekolah"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="predikat-filter-actions">
                <div className="predikat-filter-field predikat-filter-button-field">
                  <button
                    type="button"
                    className="predikat-filter-button"
                    onClick={() => GetResponseData()}
                    disabled={
                      isFetching ||
                      loadingSchool ||
                      !filterComplete
                    }
                  >
                    {isFetching ? (
                      // <PulseLoader color="#ffffff" size={5} />
                      <span>Mencari</span>
                    ) : (
                      <span>Tampilkan Data</span>
                    )}
                  </button>
                </div>

                <div className="predikat-filter-field predikat-filter-button-field">
                  <button
                    type="button"
                    className="predikat-filter-button"
                    onClick={handleOpenAdd}
                    disabled={
                      isFetching ||
                      loadingSchool ||
                      !filterComplete ||
                      hasDataForAllSemesters
                    }
                    style={{ backgroundColor: "#3f5bea" }}
                  >
                    {isFetching ? (
                      // <PulseLoader color="#ffffff" size={5} />
                      <span>Tambah Bobot</span>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faPlus} />
                        <span>Tambah Bobot</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
              
              {/* <button
                  type="button"
                  onClick={handleOpenAdd}
                  className="btn btn-create module-header-button"
                >
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Tambah Bobot</span>
                </button>
               */}
            </div>
          )}
        </section>

        {loadingMaster || loadingSchool || !filterComplete ? (
          <div
            className="module-table-card"
            style={{
              minHeight: "260px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PulseLoader color="#3f5bea" size={10} />
          </div>
        ) : (
          <>
        <div className="module-search-wrap predikat-search-section">
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            className="module-search-icon"
          />
          <input
            type="text"
            className="module-search-input"
            placeholder="Cari keterangan atau bobot..."
            value={searchKeyword}
            onChange={(event) => setSearchKeyword(event.target.value)}
          />
        </div>

        <div className="module-table-card">
          <div className="predikat-table-header">
            <h5 className="predikat-table-title">
              Atur Bobot - Semester {selectedSemester?.semester || "-"}
            </h5>

            <div className="predikat-table-header-right">
              {getData.length > 0 && (
                <div className="predikat-header-actions">
                  <button
                    type="button"
                    className="predikat-header-button predikat-header-edit"
                    onClick={() => viewModalUpdate("all", getData)}
                  >
                    <FontAwesomeIcon icon={faPenToSquare} />
                    Perbarui
                  </button>
                  <button
                    type="button"
                    className="predikat-header-button predikat-header-delete"
                    onClick={deleteById}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                    Hapus
                  </button>
                </div>
              )}

              <div className="predikat-semester-tabs" role="tablist" aria-label="Pilih semester">
                {[1, 2].map((semesterNumber) => {
                  const semester = semestersForSelectedYear.find(
                    (item) => Number(item?.semester) === semesterNumber
                  );
                  const active =
                    semester &&
                    String(semester.id) === String(filters.ysb_semester_id);

                  return (
                    <button
                      type="button"
                      role="tab"
                      key={semesterNumber}
                      className={`predikat-semester-tab ${active ? "active" : ""}`}
                      aria-selected={Boolean(active)}
                      disabled={!semester || isFetching}
                      onClick={() => handleSemesterChange(semester)}
                    >
                      Semester {semesterNumber}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="module-table-scroll">
            <table className="module-table predikat-table">
              <thead>
                <tr>
                  <th className="module-col-number predikat-col-number">No</th>
                  <th className="predikat-col-description">Keterangan</th>
                  <th className="predikat-col-value">Bobot</th>
                </tr>
              </thead>

              <tbody>
                {isFetching  ? (
                  <tr>
                    <td colSpan="3" className="module-empty-state">
                      <div className="module-empty-state-content">
                        <PulseLoader color="#3f5bea" size={9} />
                      </div>
                    </td>
                  </tr>
                ) : paginatedData.length > 0 ? (
                  paginatedData.map((row, index) => (
                    <tr key={row?.id || index}>
                      <td className="module-col-number predikat-col-number">
                        <span className="module-number-badge">
                          {(tablePage - 1) * rowsPerPage + index + 1}
                        </span>
                      </td>

                      <td>
                        <span className="predikat-description-text">
                          {row?.keterangan || "-"}
                        </span>
                      </td>

                      <td>
                        <span className="predikat-value-badge">
                          {row?.bobot ?? "-"}
                        </span>
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="module-empty-state">
                      <div className="module-empty-state-content">
                        {hasLoadedData
                          ? " Data bobot belum tersedia"
                          : "Pilih filter lalu klik Tampilkan Data"}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {!isFetching && filteredData.length > 0 && (
            <div className="module-pagination">
              <div className="module-pagination-left">
                <span className="module-page-info">
                  Menampilkan <b>{startRow}</b>-<b>{endRow}</b> dari{" "}
                  <b>{totalRows}</b> data
                </span>

                <select
                  className="module-page-size"
                  value={rowsPerPage}
                  onChange={(event) => {
                    setRowsPerPage(Number(event.target.value) || 10);
                    setTablePage(1);
                  }}
                >
                  <option value={10}>10 / halaman</option>
                  <option value={25}>25 / halaman</option>
                  <option value={50}>50 / halaman</option>
                  <option value={100}>100 / halaman</option>
                </select>
              </div>

              <div className="module-pagination-right">
                <button
                  type="button"
                  className="module-page-nav"
                  onClick={() => goToPage(tablePage - 1)}
                  disabled={tablePage <= 1}
                  aria-label="Halaman sebelumnya"
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                  <span>Sebelumnya</span>
                </button>

                <div className="module-page-numbers">
                  {pageNumbers.map((page, index) =>
                    page === "..." ? (
                      <span key={`dots-${index}`} className="module-page-dots">
                        ...
                      </span>
                    ) : (
                      <button
                        type="button"
                        key={`page-${page}`}
                        className={`module-page-number ${
                          page === tablePage ? "active" : ""
                        }`}
                        onClick={() => goToPage(page)}
                      >
                        {page}
                      </button>
                    )
                  )}
                </div>

                <button
                  type="button"
                  className="module-page-nav"
                  onClick={() => goToPage(tablePage + 1)}
                  disabled={tablePage >= totalPages}
                  aria-label="Halaman berikutnya"
                >
                  <span>Selanjutnya</span>
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
            </div>
          )}
        </div>
          </>
        )}
      </div>
    </div>
  );
}
